import { post } from '../utils/request';

const CommonApi = {};

CommonApi.getWxOpenId = (params) => {
    return post('/share/get_wx_union', params);
};

export default CommonApi;